import { FC } from "react";

interface MarginaliaTitleProps {
	title: string;
}

const MarginaliaTitle: FC<MarginaliaTitleProps> = ({ title }) => (
	<p className="text-xs font-bold uppercase tracking-widest text-[#999]">
		{title}
	</p>
);

export { MarginaliaTitle };
